import UserAppContext from '../../hook/UserAppContext';
import './friends.css';

const FriendContent = ({children}) => {

      const {user} = UserAppContext()
      const {friends} = user.user;

      if(friends.data) return;

      return (
            <div className="jd_theme__friends">
                  <div className="container friend">
                        <div className="jd_friends__title">
                              <h2>Friends</h2>
                        </div>
                        <div className="jd_friend__content">
                              {children}
                        </div>
                  </div>
            </div>
      )
}

export default FriendContent;